<template>
  <div class="notification-container">
    <div class="d-flex justify-content-between align-items-center mt60 mb-4 position-relative">
      <h4 class="fw700 font32 gray900 mb-0">Notifications</h4>
      <font-awesome-icon class="cp font24 gray400" :icon="['far', 'ellipsis-v']" @click.stop="() => (showNotificationsOptions = !showNotificationsOptions)" />
      <div class="position-absolute shadow-card notiOptsContainer" v-if="showNotificationsOptions" @click.stop="() => (showNotificationsOptions = false)">
        <p v-if="unreadNotificationCount" @click="markAllRead">
          <font-awesome-icon size="1x" :icon="['fal', 'check']" class="font-black mx-2" />
          Mark all as read
        </p>
        <p @click="$router.push({ name: 'NotificationSettings' })">
          <font-awesome-icon size="1x" :icon="['fal', 'cog']" class="font-black mx-2" />
          Notification settings
        </p>
      </div>
    </div>

    <div v-if="!notifications.length && !isLoading">
      <h4 class="no-notification main-notification-container mt-5">There are no notifications yet.</h4>
    </div>
    <div v-if="notifications.length">
      <div class="mb-4 gray800 fw700 font16">Today</div>
      <div class="todayNotiC" v-if="todayNoti.length">
        <div v-for="(notification, index) in todayNoti" :key="index" :style="{ background: notification.is_read ? '#fff' : '#F1F5F9', width: '100%' }">
          <div class="d-flex mb-4 align-items-center cp" :style="{ height: '90px' }" @click="() => notificationRouter(notification)">
            <font-awesome-icon v-if="hideNotiUser(notification.notification_text)" :icon="['fas', 'flag']" class="font24 p23 error300 bg-error50 rounded-circle mr-3 ml-2" />
            <a-avatar
              v-else
              :style="{ color: ' #ffffff !important', 'background-color': notification.sender_user[0].url ? '' : getAvatarColor(notification.sender_user[0].id) }"
              :size="70"
              class="post-list-image round-img small-avatar-image ml-2 text-capitalize mr-3"
              :src="notification.sender_user.length ? notification.sender_user[0].url : ''"
            >
              {{
                notification.sender_user[0].firstName
                  ? notification.sender_user[0].firstName[0]
                  : notification.sender_user[0].display_name
                  ? notification.sender_user[0].display_name[0]
                  : notification.sender_user[0].first_name[0]
              }}
            </a-avatar>
            <div>
              <div class="notif-text mb-0">
                <div v-if="notification.sender_user.length">
                  <span class="text-truncate text-capitalize gray800 fw700">
                    {{
                      hideNotiUser(notification.notification_text)
                        ? "Someone"
                        : ["doctor", "physician"].includes(notification.sender_user[0].role) && notification.notification_text === "added you to circle"
                        ? `Doctor ${notification.sender_user[0].display_name}`
                        : notification.sender_user[0].display_name
                    }}
                  </span>
                </div>
                <p class="mb-0 gray800 text-capitalize">
                  {{
                    getNewNotificationText(
                      notification.notification_text,
                      notification.sender_user[0].display_name,
                      notification.sender_user[0].role,
                      notification.sender_user[0].gender,
                      notification.receiver_user[0].role
                    )
                  }}
                </p>
              </div>
              <p class="notif-text-small mb-0 gray400 font12">
                {{ formatPostTime(notification.notification_time)[0] }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="gray800 fw700 font16 text-center" v-if="!isToday">No New Notifications</div>

      <div class="mb-4 gray800 fw700 font16" v-if="isEarli">Earlier</div>
      <div v-if="earlierNoti.length" class="earlierNotiC">
        <div v-for="(notification, index) in earlierNoti" :key="index" :style="{ background: notification.is_read ? '#fff' : '#F1F5F9', width: '100%' }" class="">
          <div class="d-flex mb-4 align-items-center cp" :style="{ height: '90px' }" @click="() => notificationRouter(notification)">
            <font-awesome-icon v-if="hideNotiUser(notification.notification_text)" :icon="['fas', 'flag']" class="font24 p23 error300 bg-error50 rounded-circle mr-3 ml-2" />
            <a-avatar
              v-else
              :style="{ color: ' #ffffff !important', 'background-color': notification.sender_user[0].url ? '' : getAvatarColor(notification.sender_user[0].id) }"
              :size="70"
              class="post-list-image round-img small-avatar-image ml-2 text-capitalize mr-3"
              :src="notification.sender_user.length ? notification.sender_user[0].url : ''"
            >
              {{
                notification.sender_user[0].firstName
                  ? notification.sender_user[0].firstName[0]
                  : notification.sender_user[0].display_name
                  ? notification.sender_user[0].display_name[0]
                  : notification.sender_user[0].first_name[0]
              }}
            </a-avatar>
            <div>
              <div class="notif-text mb-0">
                <div v-if="notification.sender_user.length">
                  <span class="text-truncate text-capitalize gray800 fw700">
                    {{
                      hideNotiUser(notification.notification_text)
                        ? "Someone"
                        : ["doctor", "physician"].includes(notification.sender_user[0].role) && notification.notification_text === "added you to circle"
                        ? `Doctor ${notification.sender_user[0].display_name}`
                        : notification.sender_user[0].display_name
                    }}
                  </span>
                </div>
                <p class="mb-0 gray800 text-capitalize">
                  {{
                    getNewNotificationText(
                      notification.notification_text,
                      notification.sender_user[0].display_name,
                      notification.sender_user[0].role,
                      notification.sender_user[0].gender,
                      notification.receiver_user[0].role
                    )
                  }}
                </p>
              </div>
              <p class="notif-text-small mb-0 gray400 font12">
                {{ formatPostTime(notification.notification_time)[0] }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- </ul> -->
      <span v-if="pagination && notifications.length != pagination.total_count" :style="{ color: getPrimaryColor(), display: 'block' }" @click="fetchNotifications(true)" class="cp text-center">
        View More
      </span>
      <div v-else-if="!isEarli" class="gray800 font16 fw700 text-center">No Old Notifications</div>
    </div>
    <div v-if="isLoading" class="d-flex justify-content-center my-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"

const default_image = require("../../assets/images/icon_profile.svg")
const AppRepository = RepositoryFactory.get("app")
const questions = RepositoryFactory.get("qa")

export default {
  name: "Notification",
  data() {
    return {
      notifications: [],
      pagination: null,
      currentPage: 1,
      limit: 5,
      todayNoti: [],
      earlierNoti: [],
      isEarli: false,
      isToday: false,
      showNotificationsOptions: false,
      isLoading: false,
      unreadNotificationCount: 0,
    }
  },

  created() {
    this.fetchNotifications()
    // this.allChecked()
    window.addEventListener("mouseup", () => {
      if (this.showNotificationsOptions) {
        setTimeout(() => {
          this.showNotificationsOptions = false
        }, 100)
      }
    })
  },

  methods: {
    markAllRead() {
      const headers = { Authorization: `Bearer ${this.authUser.user.token}` }
      this.$http
        .put(`${process.env.BASE_API_URL}/notifications/?user_id=${this.authUser.user.id}&circle_id=${this.currentCircle.id}&role=${this.authUser.user.role}`, { is_read: true }, { headers })
        .then(res => {
          this.currentPage = 1
          this.fetchNotifications()
        })
        .catch(err => {
          this.currentPage = 1
          this.fetchNotifications()
        })
    },
    allChecked() {
      AppRepository.allNotificationsChecked(this.authUser.user, this.currentCircle.id)
        .then(res => {})
        .catch(err => {})
    },
    /**
     * Fetch Notifications
     */
    fetchNotifications(append = false) {
      this.isLoading = true
      AppRepository.getNotifications(this.currentCircle.id, this.currentPage, this.limit, this.authUser.user)
        .then(res => {
          if (append) {
            this.notifications.push(...res.data.data.data)
          } else {
            this.notifications = res.data.data.data || []
          }
          this.pagination = res.data.data.paginator
          this.todayNoti = this.notifications.filter(x => {
            return moment(x.notification_time).dayOfYear() == moment().dayOfYear()
          })
          this.earlierNoti = this.notifications.filter(x => {
            return moment(x.notification_time).dayOfYear() !== moment().dayOfYear()
          })
          this.isToday = !!this.todayNoti.length
          this.isEarli = !!this.earlierNoti.length
          // console.log("noti ->", this.notifications)
          // console.log("pagi ->", this.pagination)
          this.currentPage += 1
          this.isLoading = false
          this.unreadNotificationCount = res.data.data.hasOwnProperty("paginator") ? res.data.data.paginator.read_count : 0
        })
        .catch(err => {
          this.isLoading = false
        })
    },

    /**
     * Route to notification settings page
     */
    showNotificationSettings() {
      this.$router.push({ name: "NotificationSettings" })
    },

    notificationRouter(data) {
      const id = data.ext_red_id ? data.ext_red_id : data.id

      AppRepository.readNotifications(id).then(res => {
        if (data.element_type) {
          console.log("data ->", data)
          console.log("data.element_type ->", data.element_type)
          // let rout = data.element_type
          // if (rout == "add to circle") {
          //   this.viewProfile(data.sender_user[0])
          // } else if (data.element_type === "post") {
          //   this.$router.push({ path: `home/view/post/${data.element_id}` })
          // } else if (data.element_type === "question") {
          //   this.$router.push({ path: `home/qa/share/${data.element_id}` })
          // } else if (data.element_type === "poll") {
          //   this.$router.push({
          //     path: `home/resources/poll/${data.element_id}`,
          //   })
          // } else if (data.element_type === "trivia") {
          //   this.$router.push({
          //     path: `home/resources/trivia/${data.element_id}`,
          //   })
          // } else if (data.element_type === "slideshow") {
          //   this.$router.push({
          //     path: `home/resources/slideshow/${data.element_id}`,
          //   })
          // } else {
          //   this.viewProfile(data.sender_user[0])
          // }
          //this.$router.push({ path: `home/view/post/${data.element_id}/about` });
          // console.log(rout,"rout")

          if (data.element_type == "add to circle") {
            this.viewProfile(data.sender_user[0])
          } else if (["post", "review", "recommend"].includes(data.element_type)) {
            this.$router.push({ name: "NotificationView", params: { type: data.element_type, id: data.element_id } })
          } else if (data.element_type === "say hi") {
            this.$router.push({ name: "NotificationView", params: { type: "post", id: data.element_id } })
            // } else if (["job", "press", "event", "poll"].includes(data.element_type)) {
            //   this.$notification.info({ message: "Yet to be added" })
            // } else if (data.element_type === "question") {
            //   this.$router.push({ name: "NotificationView", params: { type: data.element_type, id: data.element_id } })
          } else if (["job", "event", "poll", "question"].includes(data.element_type)) {
            this.$router.push({ name: "NotificationView", params: { type: data.element_type, id: data.element_id } })
          } else if (["press release", "press"].includes(data.element_type)) {
            this.$router.push({ name: "NotificationView", params: { type: "press", id: data.element_id } })
            // this.$router.push({ name: "ShowSharedQuestion", params: { id: data.element_id } })
            // this.$router.push({ path: `home/qa/share/${data.element_id}` })
          } else if (["comment"].includes(data.element_type)) {
            this.$router.push({ name: "NotificationView", params: { type: data.element_parent_type, id: data.element_parent_id, cmnttype: data.element_type, cmntid: data.element_id } })
            // this.$router.push({ path: `home/view/${data.element_parent_type}/${data.element_parent_id}` })
          } else if (["reply"].includes(data.element_type)) {
            this.$router.push({ path: `home/view/${data.element_parent_type}/${data.element_parent_id}/${data.element_type}/${data.element_id}` })
          } else {
            this.viewProfile(data.sender_user[0])
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.notification-container {
  padding-bottom: 24px;
  min-height: 90vh;
  // min-height: 73vh;
  margin: auto;
  // width: 650px;
  width: 792px;
  // .m-notification-menu {
  //   justify-content: space-between;
  // }
  img {
    width: 64px;
    height: 64px;
    border-radius: 32px;
  }
}
.noti-radius {
  border-radius: 10px;
  padding: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.no-notification {
  text-align: center;
  padding: 30px;
  font-size: 22px;
}

.notiOptsContainer {
  z-index: 1;
  padding: 8px 16px;
  right: 0;
  top: 30px;
  p {
    cursor: pointer;
    padding: 6px;
    color: #1e2945 !important;
    font-size: 16px;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
@media screen and (max-width: 600px) {
  .mt60 {
    margin-top: 24px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App/Notification.vue